'use client';

import { createGlobalStyle } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

/**
 * [useLpScroll] 훅이 전제하는 스크롤 동작 규칙과 카테고리 탭 영역 스타일.
 * 훅과 한 세트다 — 훅을 쓰는 페이지에서 <LpScrollStyle />을 한 번 렌더한다.
 */
export const LpScrollStyle = createGlobalStyle`
  .lp-filter-bar {
    /* 래퍼는 상자 없이 자식만 그린다. 퀵 필터 줄은 흐름에 남기고 .pin-area만 붙인다 */
    display: contents;

    .pin-area {
      position: sticky !important;
      top: var(--brand-pin-top, 50px);
      left: 0;
      z-index: 11;
    }
  }

  .bottom-product-wrap {
    /**
     * 새 뎁스 행이 붙을 때의 등장 모션 값.
     * 밀려날 거리는 화면폭·글꼴에 따라 달라 스크립트가 재고, 길이와 곡선은 여기서 정한다.
     * 접힘/펼침(transition: transform 0.3s)과 같은 길이로 맞춰 둔다.
     */
    --depth-in-duration: 300ms;
    --depth-in-easing: ease;

    &.is-pinned {
      .inner-area-menu {
        position: fixed;
        top: 50px;
        left: 0;
        width: 100%;
        z-index: 11;
        background-color: #fff;
        /* 높이에 얹히지 않게 테두리 대신 그림자 */
        box-shadow: inset 0 -1px 0 #eee;
      }
    }

    &.is-stuck {
      .inner-area-menu {
        transition: transform 0.3s;
      }

      .inner-area-menu::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #fff;
      }

      .lp-filter-bar .pin-area {
        transition: transform 0.3s;
      }
    }

    .area-menu {
      .category-menubar {
        border-top: none;

        &:nth-child(-n + 2) {
          border-bottom: 1px solid #eee;
        }

        .swiper {
          padding: 0 16px;
        }

        &.cm-type4 {
          .menubar-swiper {
            background-color: #f6f6f6;
          }

          .swiper-slide {
            margin-right: 12px;
          }
        }
      }
    }

    /* 뎁스가 통째로 밀려 올라가므로 각 뎁스를 제 문맥에 가둬 안쪽 스와이퍼가
       위 레이어로 새어 나오지 않게 한다 */
    .inner-area-menu .category-menubar {
      position: relative;
      z-index: 0;
    }

    .area-menu.is-4deps .inner-area-menu {
      box-shadow: none;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .bottom-product-wrap {
      .area-menu {
        .category-menubar {
          .swiper {
            padding: ${mixin.pxToVw('0 16')};
          }

          &.cm-type4 {
            .swiper-slide {
              margin-right: ${mixin.pxToVw('12')};
            }
          }
        }
      }
    }
  }

  /* PC는 헤더가 상단 고정이 아니라 필터 바를 화면 최상단에 붙인다 */
  @media ${({ theme }) => theme.media.pc} {
    .lp-filter-bar .pin-area {
      top: 0;
    }
  }
`;
